import { Box, Grid } from "@mui/material";
import React, { useState, useEffect } from "react";
import Status from "../../../stories/StatusComponent/StatusComponent";
import FormGroup from "@mui/material/FormGroup";
import FormControlLabel from "@mui/material/FormControlLabel";
import Checkbox from "@mui/material/Checkbox";
import Radio from "@mui/material/Radio";
import RadioGroup from "@mui/material/RadioGroup";
import InputLabel from "@mui/material/InputLabel";
import MenuItem from "@mui/material/MenuItem";
import FormControl from "@mui/material/FormControl";
import Select from "@mui/material/Select";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { TextField, Stack } from "@mui/material";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";
import axios from "../../../utils/fvAxios";
import ListItemText from "@mui/material/ListItemText";
import { Chip } from "@mui/material";
import GetfVDateFormate from "../../../utils/Genaricfunctions";
import apiinfo from "../../../utils/base-uri.json";
import STATUSJSON from "../../../stories/StatusComponent/status.json";
import Button from "../../../toolkit/ButtonV1";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
// import { DemoContainer } from '@mui/x-date-pickers/internals/demo';
import AccordionSummary from "@mui/material/AccordionSummary";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import { styled } from "@mui/material/styles";
import MuiAccordion, { AccordionProps } from "@mui/material/Accordion";
import MuiAccordionDetails from "@mui/material/AccordionDetails";
import Typography from "@mui/material/Typography";
import { useTranslation } from "react-i18next";
import "../../../Localization/i18n";

const Accordion = styled((props) => (
  <MuiAccordion disableGutters elevation={0} square {...props} />
))(({ theme }) => ({
  border: `1px solid ${theme.palette.divider}`,
  "&:not(:last-child)": {
    borderBottom: 0,
  },
  "&:before": {
    display: "none",
  },
}));

const AccordionDetails = styled(MuiAccordionDetails)(({ theme }) => ({
  padding: theme.spacing(2),
  borderTop: "1px solid rgba(0, 0, 0, .125)",
}));

export default function VendorStatusChange({
  props,
  Viewed,
  Pageload,
  Refresh,
  updateStatus
}) {
  const { t } = useTranslation();
  const params = new URLSearchParams(window.location.search);
  const PQID = params.get("pqid");
  const Type = params.get("Type");

  const MenuProps = {
    PaperProps: {
      style: {
        maxHeight: 50 * 5 + 8,
        width: 200,
      },
    },
  };

  const toastNotify = (message, isSuccess = true) => {
    if (isSuccess) {
      toast.success(message, {
        position: "top-right",
        autoClose: 2000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        theme: "light",
      });
    } else {
      toast.error(message, {
        position: "top-right",
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        theme: "light",
      });
    }
  };


  const date = new Date();
  const [newPeriodDate, setNewPeriodDate] = React.useState(
    GetfVDateFormate("", "", date)
  );
  const [newStatusDate, setNewStatusDate] = React.useState(
    GetfVDateFormate("", "", date)
  );
  // const [view, setView] = useState(true);
  // const Viewed = () => {
  //   setView(view => !view);
  // }

  const [expanded, setExpanded] = React.useState(false);
  const ChangeExpanded = () => {
    setExpanded(expanded);
  };

  const NewPeriodDateChange = (e) => {
    setNewPeriodDate(GetfVDateFormate("", "", e?.$d));
  };
  const NewStatusDateChange = (e) => {
    setNewStatusDate(GetfVDateFormate("", "", e?.$d));
  };

  const [adminUsersId, setAdminUsersId] = useState("");
  const adminUsersChange = (e) => {
    setAdminUsersId(e);
  };
  const [changeSiteStatusesId, setChangeSiteStatusesId] = useState("");

  // const ChangeSiteStatuses = (e) => {
  //   setChangeSiteStatusesId(e);
  // }

  const [sectionId, setSectionId] = useState([]);
  const [groupSections, setGroupSections] = useState([]);
  const [displayDataEntryId, setDisplayDataEntryId] = useState([]);
  const [displayDataEntry, setDisplayDataEntry] = useState([]);
  const [statusPeriodLength, setStatusPeriodLength] = useState("");
  const [statusPeriodLengthText, setStatusPeriodLengthText] = useState("");
  const [exceptionProbation, setExceptionProbation] = useState(false);
  // const [confirmChange, setConfirmChange] = useState("2");
  const [checked, setChecked] = useState(false);
  const [newStatusId, setNewStatusId] = useState("");

  const [sections, setSections] = React.useState([]);
  const [clientDataEntrySections, setClientDataEntrySections] = React.useState(
    []
  );
  const [info, setInfo] = React.useState({});
  const [statuses, setStatuses] = React.useState([]);
  const [adminUsers, setAdminUsers] = React.useState([]);

  const [dis, setDis] = useState(false);

  statuses?.sort((a, b) => a.prequalificationStatus.localeCompare(b.prequalificationStatus));

  const StatusChange = (event) => {
    setNewStatusId(event.target.value);
    setChecked(false);
    const data = statuses?.find(
      (r) => r?.prequalificationStatusId == event.target.value
    );
    if (event?.target?.value == 10) {
      StatusPeriodLengthTextChange(data?.periodLength);
      StatusPeriodLengthDroupChange(data?.periodLengthUnit);
      adminUsersChange("");
      setNewPeriodDate("");
      setNewStatusDate("");
    } else if (event?.target?.value == 16) {
      adminUsersChange("");
      StatusPeriodLengthTextChange(data?.periodLength);
      StatusPeriodLengthDroupChange(data?.periodLengthUnit);
      setNewPeriodDate(GetfVDateFormate("", "", date));
      setNewStatusDate(GetfVDateFormate("", "", date));
    } else {
      StatusPeriodLengthTextChange(data?.periodLength);
      StatusPeriodLengthDroupChange(data?.periodLengthUnit);
      setNewPeriodDate(GetfVDateFormate("", "", date));
      setNewStatusDate(GetfVDateFormate("", "", date));
    }
  };

  const StatusPeriodLengthDroupChange = (e) => {
    setStatusPeriodLength(e);
  };
  const StatusPeriodLengthTextChange = (e) => {
    setStatusPeriodLengthText(e);
  };

  const ExceptionProbationHandlar = (e) => {
    if (e == "true") {
      setExceptionProbation(true);
    } else if (e == "false") {
      setExceptionProbation(false);
    }
  };
  // const ConfirmChangeHandlar = (e) => {
  //   setConfirmChange(e);
  // }
  const ConformationHandlar = (event) => {
    setChecked(event.target.checked);
  };

  const [pqLocations, setPqlocations] = useState([]);
  async function GetPQLocations() {
    const res = await axios.get(apiinfo.vendor.PQLocations + "pqId=" + PQID);
    setPqlocations(res?.data?.data);
  }

  const SectionChange = (e) => {
    setGroupSections(typeof e === "string" ? e.split(",") : e);
    setSectionId(e);
  };
  const DisplayDataEntry = (e) => {
    setDisplayDataEntry(typeof e === "string" ? e.split(",") : e);
    setDisplayDataEntryId(e);
  };

  async function GetPQChangeStatusInfo() {

    const res = await axios.get(
      "/Prequalification/GetPQChangeStatusInfo?pqId=" + PQID
    );
    setSections(res?.data?.data?.sections);
    setClientDataEntrySections(res?.data?.data?.displayClientDataEntrySections);
    setInfo(res?.data?.data);
    setChangeSiteStatusesId(res?.data?.data?.pqStatusId);
    setAdminUsersId(res?.data?.data?.userIdAsSigner);
  }
  async function GetprequalificationStatuses() {
    const res = await axios.get(
      "/Prequalification/GetprequalificationStatuses"
    );
    setStatuses(res?.data?.data);
    //setNewStatusId(res?.data?.data[0]?.prequalificationStatusId);
  }
  async function GetAdminUsers() {
    const res = await axios.get("/Prequalification/GetAdminUsers");
    let activeRec = res?.data?.data.filter(r => r.status)
    setAdminUsers(activeRec);
    // if (activeRec.length > 0) {
    //   setAdminUsersId(activeRec[0]?.userId);   
    // }
  }

  useEffect(() => {
    GetPQChangeStatusInfo();
    GetprequalificationStatuses();
    GetAdminUsers();
    GetPQLocations();
  }, [Refresh]);

  const StatusName = STATUSJSON.find((r) => r?.value == info?.pqStatusId);

  // const groupByCategory = Object.entries(pqLocations?.reduce((group, product) => {
  //   const { clientName } = product;
  //   group[clientName] = group[clientName] ?? [];
  //   group[clientName].push(product);
  //   return group;

  // }, {}));

  const groupedData = pqLocations.reduce((acc, curr) => {
    const clientKey = curr.clientName;
    const buKey = curr.businessUnitName;
    if (!acc[clientKey]) {
      acc[clientKey] = {};
    }
    if (!acc[clientKey][buKey]) {
      acc[clientKey][buKey] = [];
    }
    acc[clientKey][buKey].push(curr);
    return acc;
  }, {});

  const [selectedStatus, setSelectedStatus] = useState("");

  const handleStatusChange = (site, status) => {
    setSelectedStatus((prevState) => ({
      ...prevState,
      [site]: status,
    }));
  };

  const updateSiteStatus = (siteId, newStatus) => {
    const data = {
      siteId: siteId,
      status: newStatus,
    };
    const updatedStatuses = [data];

    axios
      .post("Prequalification/ChanngeLocationStatus", updatedStatuses)
      .then((res) => {
        if (res?.data?.data) {
          toastNotify("Updated Successfully", true);
          updateStatus(true);
        } else {
          toastNotify(res?.data?.data, false);
        }
      })
      .catch((err) => {
        console.log(err);
      });

  };
  const StatusList = [31, 13, 14, 7, 32, 33, 4, 9, 8, 26, 5, 3, 15];
  const SaveChangeStatus = () => {
    setDis(true);
    if ((StatusList?.includes(newStatusId)) && (!newStatusId || !statusPeriodLength || !newPeriodDate || !newStatusDate || !statusPeriodLengthText || !adminUsersId)) {
      toastNotify("Please Enter Mandatroy Fields", false);
      setDis(false);
    } else if ((newStatusId == 16) && (!newStatusId || !statusPeriodLength || !statusPeriodLengthText || !newPeriodDate || !newStatusDate)) {
      toastNotify("Please Enter Mandatroy Fields", false);
      setDis(false);
    } else if (!newStatusId) {
      toastNotify("Please Enter Mandatroy Fields", false);
      setDis(false);
    } else {
      const SectionId = sectionId?.map((r) => {
        return {
          sectionId: r?.value,
          secName: r?.text,
        };
      });
      const DataEntry = displayDataEntryId?.map((r) => {
        return {
          templateSectionId: r?.templateSectionId,
          sectionName: r?.sectionName,
          visible: true,
          status: true,
        };
      });
      const data = {
        prequalificationId: PQID,
        pqStatusId: info?.pqStatusId,
        newStatus: newStatusId,
        currentStatus: StatusName?.key,
        newPeriodStart: newPeriodDate,
        newStatusChanged: newStatusDate,
        notCompletedSection: SectionId,
        periodLengthUnit: statusPeriodLength, // D,M,Y
        periodLength: statusPeriodLengthText, //NUMBER
        requestForMoreInfo: exceptionProbation, //Exception/Probation section
        adminUserId: adminUsersId,
        displayTemplateSections: DataEntry,
      };

      axios
        .post("Prequalification/SavePQChangeStatus", data)
        .then((res) => {
          if (res?.data?.data == "Success") {
            toastNotify(res?.data?.data, true);
            window.location.reload();
            setDis(false);
            Pageload(!Refresh);
          } else {
            toastNotify(res?.data?.responseMessage, false);
            setDis(false);
          }
        })
        .catch((err) => {
          console.log(err);
        });

    }
    // window.location.reload();
    // Viewed();
  };
  const handleDateKeyDown = (e) => {
    e.preventDefault();// Prevent manual date input
  };
  const DisPayment = [9, 26, 13, 8, -1, 31]
  return (
    <>
      <Box sx={{ padding: "20px" }}>
        {/* <ToastContainer /> */}
        <Box
          border={1}
          borderLeft={1}
          borderRight={1}
          borderColor="#e4e7ec"
          className="mt-2"
          sx={{ padding: "10px", background: "#fff" }}
        >
          <h4 style={{ paddingLeft: "12px" }}>{t("StatusChange.label1")}</h4>
          <Box>
            <br />
            <Grid
              container
              spacing={{ xs: 2, md: 3 }}
              columns={{ xs: 4, sm: 8, md: 12 }}
              sx={{ paddingLeft: "12px" }}
            >
              <Grid item xs={12} sm={4} md={4}>
                <p style={{ fontSize: "400", color: "#101828" }}>
                  {t("StatusChange.label2")}
                </p>
              </Grid>
              <Grid item xs={2} sm={4} md={4}>
                <Status type={info?.pqStatusId} />
              </Grid>
            </Grid>
            <hr />
            <Grid
              container
              spacing={{ xs: 2, md: 3 }}
              columns={{ xs: 4, sm: 8, md: 12 }}
              sx={{ paddingLeft: "12px" }}
            >
              <Grid item xs={12} sm={4} md={4}>
                <p style={{ color: "#101828" }}>{t("StatusChange.label3")}</p>
              </Grid>
              <Grid item xs={2} sm={4} md={4}>
                <p style={{ marginLeft: "5px", color: "#101828" }}>
                  {info?.currentStatusPeriod}
                </p>
              </Grid>
            </Grid>

            <Box
              sx={{ width: "auto", padding: "8px", backgroundColor: "#F2F4F7" }}
            >
              <p
                style={{
                  fontSize: "16px",
                  fontWeight: "600",
                  color: "#667085",
                  marginTop: "10px",
                  padding: "5px",
                }}
              >
                {" "}
                {t("StatusChange.label4")}
              </p>
            </Box>

            <Box sx={{ padding: "15px" }}>
              <Grid
                container
                spacing={{ xs: 2, md: 3 }}
                columns={{ xs: 4, sm: 8, md: 12 }}
              >
                <Grid item xs={12} sm={4} md={4}>
                  <p style={{ fontSize: "400", color: "#101828" }}>
                    {t("StatusChange.label5")}{" "}
                    <span style={{ color: "red" }}>*</span>
                  </p>
                </Grid>
                <Grid item xs={2} sm={4} md={4}>
                  <FormControl fullWidth>
                    <Select
                      labelId="demo-simple-select-label"
                      id="demo-simple-select"
                      value={newStatusId}
                      label="Age"
                      onChange={StatusChange}
                      size="small"
                      sx={{
                        width: "299px",
                        "& legend": { display: "none" },
                        "& fieldset": { top: 0 },
                      }}
                      MenuProps={MenuProps}
                    >
                      {statuses?.map((r) => (
                        <MenuItem hidden={r?.prequalificationStatusId == -1}
                          key={r?.prequalificationStatusId}
                          value={r?.prequalificationStatusId}
                        >
                          {r?.prequalificationStatus}
                        </MenuItem>
                      ))}
                    </Select>
                  </FormControl>
                </Grid>
              </Grid>

              <hr />

              <Grid
                container
                spacing={{ xs: 2, md: 3 }}
                columns={{ xs: 4, sm: 8, md: 12 }}
                sx={{
                  display: !newStatusId || newStatusId == 10 ? "none" : "",
                }}
              >
                <Grid item xs={12} sm={4} md={4}>
                  <p style={{ fontSize: "400", color: "#101828" }}>
                    {" "}
                    {t("StatusChange.label6")}{" "}
                    <span style={{ color: "red" }}>*</span>
                  </p>
                </Grid>
                <Grid item xs={2} sm={4} md={4}>
                  <Stack direction="row" spacing={2}>
                    <FormControl>
                      <TextField
                        sx={{
                          "& legend": { display: "none" },
                          "& fieldset": { top: 0 },
                          width: "140px",
                        }}
                        size="small"
                        id="outlined-name"
                        type="number"
                        InputProps={{ inputProps: { min: "1" } }}
                        value={statusPeriodLengthText}
                        onChange={(e) => StatusPeriodLengthTextChange(e.target.value)}
                      />
                    </FormControl>
                    <FormControl>
                      <Select
                        labelId="demo-simple-select-label"
                        id="demo-simple-select"
                        value={statusPeriodLength}
                        onChange={(e) =>
                          StatusPeriodLengthDroupChange(e.target.value)
                        }
                        size="small"
                        sx={{
                          width: "140px",
                          "& legend": { display: "none" },
                          "& fieldset": { top: 0 },
                        }}
                      >
                        <MenuItem key={1} value="Y">
                          {t("StatusChange.label7")}
                        </MenuItem>
                        <MenuItem key={2} value="M">
                          {t("StatusChange.label8")}
                        </MenuItem>
                        <MenuItem key={3} value="D">
                          {t("StatusChange.label9")}
                        </MenuItem>
                      </Select>
                    </FormControl>
                  </Stack>
                </Grid>
              </Grid>

              <hr
                style={{
                  display: !newStatusId || newStatusId == 10 ? "none" : "",
                }}
              />

              <Grid
                container
                spacing={{ xs: 2, md: 3 }}
                columns={{ xs: 4, sm: 8, md: 12 }}
                sx={{ display: newStatusId == 10 ? "none" : "" }}
              // hidden={newStatusId == 10}
              >
                <Grid item xs={12} sm={4} md={4}>
                  <p style={{ fontSize: "400", color: "#101828" }}>
                    {t("StatusChange.label10")}
                    <span style={{ color: "red" }}>*</span>
                  </p>
                </Grid>
                <Grid item xs={2} sm={4} md={4}>
                  <LocalizationProvider dateAdapter={AdapterDayjs}>
                    <DatePicker
                      views={["year", "month", "day"]}
                      value={newPeriodDate}
                      onChange={(newValue) => {
                        NewPeriodDateChange(newValue);
                      }}
                      renderInput={(params) => (
                        <TextField
                          {...params}
                          sx={{
                            "& legend": { display: "none" },
                            "& fieldset": { top: 0 },
                            width: "299px",
                          }}
                          size="small"
                          onKeyDown={handleDateKeyDown}
                        />
                      )}
                    />
                  </LocalizationProvider>

                  {/* <TextField
                type="date"
                sx={{ width: "299px" }}
                name="fromDate"
                size="small"
                views={["year", "month", "day"]}
                value={newPeriodDate}
                onChange={(newValue) => {
                  NewPeriodDateChange(newValue);
                }}
                onKeyDown={handleDateKeyDown}
              /> */}
                  {/* <LocalizationProvider dateAdapter={AdapterDayjs}>
                    <DatePicker
                      value={newPeriodDate}
                      onChange={(newValue) => {
                        NewPeriodDateChange(newValue);
                      }}
                      renderInput={(params) => <TextField {...params}    sx={{
                        "& legend": { display: "none" },
                        "& fieldset": { top: 0 },
                        width: "299px"
                      }}
                      size="small" />}
                    />
                  </LocalizationProvider> */}
                </Grid>
              </Grid>

              <hr style={{ display: newStatusId == 10 ? "none" : "" }} />
              <Grid
                container
                spacing={{ xs: 2, md: 3 }}
                columns={{ xs: 4, sm: 8, md: 12 }}
                sx={{ display: newStatusId == 10 ? "none" : "" }}
              // hidden={newStatusId == 10}
              >
                <Grid item xs={12} sm={4} md={4}>
                  <p style={{ fontSize: "400", color: "#101828" }}>
                    {t("StatusChange.label11")}
                    <span style={{ color: "red" }}>*</span>
                  </p>
                </Grid>
                <Grid item xs={2} sm={4} md={4}>
                  <LocalizationProvider dateAdapter={AdapterDayjs}>
                    <DatePicker
                      views={["year", "month", "day"]}
                      value={newStatusDate}
                      onChange={(newValue) => {
                        NewStatusDateChange(newValue);
                      }}
                      renderInput={(params) => (
                        <TextField
                          {...params}
                          sx={{
                            "& legend": { display: "none" },
                            "& fieldset": { top: 0 },
                            width: "299px",
                          }}
                          size="small"
                          onKeyDown={handleDateKeyDown}
                        />
                      )}
                    />
                  </LocalizationProvider>
                </Grid>
              </Grid>

              <hr style={{ display: newStatusId == 10 ? "none" : "" }} />
              <Grid
                container
                spacing={{ xs: 2, md: 3 }}
                columns={{ xs: 4, sm: 8, md: 12 }}
                sx={{
                  display: newStatusId == 10 || newStatusId == 16 ? "none" : "",
                }}
              // hidden={newStatusId == 10 || newStatusId == 16}
              >
                <Grid item xs={12} sm={4} md={4}>
                  <p style={{ fontSize: "400", color: "#101828" }}>
                    {t("StatusChange.label12")}
                    <span style={{ color: "red" }}>*</span>
                  </p>
                </Grid>
                <Grid item xs={2} sm={4} md={4}>
                  <FormControl fullWidth>
                    <Select
                      labelId="demo-simple-select-label"
                      id="demo-simple-select"
                      value={adminUsersId}
                      label="Age"
                      onChange={(e) => adminUsersChange(e?.target?.value)}
                      size="small"
                      sx={{
                        width: "299px",
                        "& legend": { display: "none" },
                        "& fieldset": { top: 0 },
                      }}
                      MenuProps={MenuProps}
                    >
                      {adminUsers?.map((r) => (
                        <MenuItem key={r?.userId} title={r.fullName} value={r?.userId}>
                          {r.fullName}
                        </MenuItem>
                      ))}
                    </Select>
                  </FormControl>
                </Grid>
              </Grid>

              <hr
                style={{
                  display: newStatusId == 10 || newStatusId == 16 ? "none" : "",
                }}
              />
              <Grid
                container
                spacing={{ xs: 2, md: 3 }}
                columns={{ xs: 4, sm: 8, md: 12 }}
                sx={{
                  display: newStatusId == 10 || newStatusId == 16 ? "none" : "",
                }}
              // hidden={newStatusId == 10 || newStatusId == 16}
              >
                <Grid item xs={12} sm={4} md={4}>
                  <p style={{ fontSize: "400", color: "#101828" }}>
                    {t("StatusChange.label13")}
                  </p>
                </Grid>
                <Grid item xs={2} sm={4} md={4}>
                  <FormControl>
                    <RadioGroup
                      row
                      aria-labelledby="demo-row-radio-buttons-group-label"
                      name="row-radio-buttons-group"
                      value={exceptionProbation}
                      onClick={(e) => ExceptionProbationHandlar(e.target.value)}
                    >
                      <FormControlLabel
                        value={true}
                        control={<Radio size="small" />}
                        label="Yes"
                      />
                      <FormControlLabel
                        value={false}
                        control={<Radio size="small" />}
                        label="No"
                      />
                    </RadioGroup>
                  </FormControl>
                </Grid>
              </Grid>

              <hr
                style={{
                  display: newStatusId == 10 || newStatusId == 16 ? "none" : "",
                }}
              />
              <Grid
                container
                spacing={{ xs: 2, md: 3 }}
                columns={{ xs: 4, sm: 8, md: 12 }}
                style={{ marginTop: newStatusId == 10 ? "-20px" : "" }}
              >
                <Grid item xs={12} sm={4} md={4}>
                  <p style={{ fontSize: "400", color: "#101828" }}>
                    {t("StatusChange.label14")}
                  </p>
                </Grid>
                <Grid item xs={2} sm={4} md={4}>
                  <FormControl fullWidth>
                    <Select
                      size="small"
                      sx={{
                        "& legend": { display: "none" },
                        "& fieldset": { top: 0 },
                        width: "300px",
                      }}
                      labelId="demo-multiple-checkbox-label"
                      id="demo-multiple-checkbox"
                      multiple
                      value={groupSections}
                      onChange={(e) => SectionChange(e.target.value)}
                      renderValue={(selected) => (
                        <Box
                          sx={{
                            flexWrap: "wrap",
                            gap: 0.5,
                            overflowX: "hidden",
                          }}
                        >
                          {selected.map((data, i) => (
                            <Chip
                              sx={{ marginRight: "10px" }}
                              key={i}
                              label={data.text}
                            />
                          ))}
                        </Box>
                      )}
                      MenuProps={MenuProps}
                    >
                      {sections?.map((data, i) => (
                        <MenuItem key={i} value={data}>
                          {" "}
                          {/* hidden={data.selected === true} */}
                          <Checkbox
                            checked={groupSections.indexOf(data) > -1}
                          />
                          <ListItemText primary={data.text} />
                        </MenuItem>
                      ))}
                    </Select>
                  </FormControl>
                </Grid>
              </Grid>

              <hr />
              <Grid
                container
                spacing={{ xs: 2, md: 3 }}
                columns={{ xs: 4, sm: 8, md: 12 }}
              >
                <Grid item xs={12} sm={4} md={4}>
                  <p style={{ fontSize: "400", color: "#101828" }}>
                    {t("StatusChange.label15")}
                  </p>
                </Grid>
                <Grid item xs={2} sm={4} md={4}>
                  <FormControl fullWidth>
                    <Select
                      size="small"
                      sx={{
                        "& legend": { display: "none" },
                        "& fieldset": { top: 0 },
                        width: "300px",
                      }}
                      labelId="demo-multiple-checkbox-label"
                      id="demo-multiple-checkbox"
                      multiple
                      value={displayDataEntry}
                      onChange={(e) => DisplayDataEntry(e.target.value)}
                      renderValue={(selected) => (
                        <Box
                          sx={{
                            flexWrap: "wrap",
                            gap: 0.5,
                            overflowX: "hidden",
                          }}
                        >
                          {selected.map((data, i) => (
                            <Chip
                              sx={{ marginRight: "10px" }}
                              key={i}
                              label={data.sectionName}
                            />
                          ))}
                        </Box>
                      )}
                      MenuProps={MenuProps}
                    >
                      {clientDataEntrySections?.map((data, i) => (
                        <MenuItem key={i} value={data}>
                          {" "}
                          {/* hidden={data.selected === true} */}
                          <Checkbox
                            checked={displayDataEntry.indexOf(data) > -1}
                          />
                          <ListItemText primary={data.sectionName} />
                        </MenuItem>
                      ))}
                    </Select>
                  </FormControl>
                </Grid>
              </Grid>

              <hr />
              <Stack direction={"row"} sx={{ marginBottom: "10px" }}>
                <FormGroup>
                  <FormControlLabel
                    control={
                      <Checkbox
                        checked={checked}
                        onChange={ConformationHandlar}
                        size="medium"
                        style={{ marginLeft: "5px", text: "red" }}
                      />
                    }
                  // label="I have reviewed the Supporting Documents section for missing or expired documents before changing status to Prequalified, Exception or Probation."
                  />
                </FormGroup>
                <small style={{ color: "red", fontSize: "large" }}>
                  {t("StatusChange.label16")}
                </small>
              </Stack>

              {/* <Grid
                container
                spacing={{ xs: 2, md: 3 }}
                columns={{ xs: 4, sm: 8, md: 12 }}
              >
                <Grid item xs={12} sm={4} md={4}>
                  <p style={{ fontSize: "400", color: "#101828" }}>Confirm Change</p>
                </Grid>

                <Grid item xs={2} sm={4} md={4}>
                  <FormControl>
                    <RadioGroup
                      row
                      aria-labelledby="demo-row-radio-buttons-group-label"
                      name="row-radio-buttons-group"
                      value={confirmChange}
                      onClick={(e) => ConfirmChangeHandlar(e.target.value)}
                    >
                      <FormControlLabel
                        value="1"
                        control={<Radio size="small" />}
                        label="Yes"
                      />
                      <FormControlLabel
                        value="2"
                        control={<Radio size="small" />}
                        label="No"
                      />
                    </RadioGroup>
                  </FormControl>
                </Grid>
              </Grid> */}

              <Box>
                <Stack spacing={2} direction="row">
                  <Button
                    role="primary"
                    size="small"
                    label="Confirm & Save"
                    onClick={SaveChangeStatus}
                    sx={{ padding: "20px" }}
                    // disabled={confirmChange == 2 || checked == false}
                    disabled={checked == false || dis}
                  />
                  <Button
                    role="primary"
                    size="small"
                    label="Cancel"
                    onClick={Viewed}
                    sx={{ padding: "20px" }}
                  />
                </Stack>
              </Box>
            </Box>
          </Box>
        </Box>

        {/* <Box border={1}
          borderLeft={1}
          borderRight={1}
          borderColor="#e4e7ec" className="mt-2" sx={{ padding: "20px", background: "#fff" }}>
          <h5>Change Site Statuses</h5>

          {groupByCategory.map((r, i) => (
            <div key={i}>
              <Box sx={{ width: "auto", padding: "2px", backgroundColor: "#F9FAFB", marginTop: "10px", padding: "5px" }}>
                <p style={{ fontSize: "600", color: "#667085" }}>{r[0] == "null" ? "Global Locations" : r[0]}</p>
              </Box>

              {r[1].map((r, i) => (
                <div key={i}>
                  <Box sx={{ width: "auto", padding: "2px", backgroundColor: "#F2F4F7" }}>
                    <p style={{ marginTop: "10px", padding: "5px", fontSize: "500", color: "#667085" }}>{r.businessUnitName}</p>
                  </Box>
                  <br />
                  <Grid
                    container
                    spacing={{ xs: 2, md: 3 }}
                    columns={{ xs: 4, sm: 8, md: 12 }}
                  >
                    <Grid item xs={12} sm={4} md={4}>
                      <p style={{ fontSize: "400", color: "#101828", marginLeft: "10px" }} >{r?.businesUnitsiteName} </p>
                    </Grid>

                    <Grid item xs={2} sm={4} md={4}>
                      <Stack spacing={2} direction="row" sx={{ marginBottom: "5px" }}>
                        <FormControl fullWidth sx={{ padding: "5px" }}>
                          <Select
                            labelId="demo-simple-select-label"
                            id="demo-simple-select"
                            value={changeSiteStatusesId}
                            label="Status"
                            onChange={(e) => ChangeSiteStatuses(e.target.value)}
                            size="small"
                            sx={{
                              width: "299px", "& legend": { display: "none" },
                              "& fieldset": { top: 0 },
                            }}
                            MenuProps={MenuProps}
                          >
                            {statuses?.map((r, index) =>
                              <MenuItem key={index} value={r?.prequalificationStatusId}>{r?.prequalificationStatus}</MenuItem>
                            )}
                          </Select>
                        </FormControl>
                        <div >
                          <Button
                            role="primary"
                            size="small"
                            label="Update"
                            sx={{ padding: "20px", marginTop: "5px" }}
                          />
                        </div>
                      </Stack>

                    </Grid>
                  </Grid>
                </div>
              ))}
            </div>
          ))}
        </Box> */}

        <Box
          border={1}
          borderLeft={1}
          borderRight={1}
          borderColor="#e4e7ec"
          className="mt-2"
          sx={{ padding: "20px", background: "#fff" }}
        >
          <h5>{t("StatusChange.label17")}</h5>

          {Object.entries(groupedData).map(([clientName, clientData]) => (
            <div key={clientName}>
              <Accordion onChange={ChangeExpanded} sx={{ marginTop: "20px" }}>
                <AccordionSummary
                  expandIcon={
                    <ExpandMoreIcon
                      sx={{ color: "#667085", fontWeight: "300" }}
                    />
                  }
                  aria-controls="panel4bh-content"
                  id="panel4bh-header"
                  sx={{ backgroundColor: "#F2F4F7" }}
                >
                  <Typography
                    sx={{
                      flexShrink: 0,
                      fontSize: "16",
                      fontWeight: "600",
                      color: "#667085",
                    }}
                  >
                    {" "}
                    {clientName == "null" ? "Global Locations" : clientName}
                  </Typography>
                </AccordionSummary>
                <AccordionDetails>
                  {Object.entries(clientData).map(([buName, buData]) => (
                    <div key={buName}>
                      <Box
                        sx={{
                          width: "auto",
                          padding: "2px",
                          backgroundColor: "#F2F4F7",
                        }}
                      >
                        <p
                          style={{
                            marginTop: "10px",
                            padding: "5px",
                            fontSize: "500",
                            color: "#667085",
                          }}
                        >
                          {buName}
                        </p>
                      </Box>
                      <br />
                      {buData.map((site, i) => (
                        <Grid
                          key={i}
                          container
                          spacing={{ xs: 2, md: 3 }}
                          columns={{ xs: 4, sm: 8, md: 12 }}
                        >
                          <Grid item xs={12} sm={4} md={4}>
                            <p
                              style={{
                                fontSize: "400",
                                color: "#101828",
                                marginLeft: "10px",
                              }}
                            >
                              {site?.businesUnitsiteName}{" "}
                            </p>
                          </Grid>

                          <Grid item xs={2} sm={4} md={4}>
                            <Stack
                              spacing={2}
                              direction="row"
                              sx={{ marginBottom: "5px" }}
                            >
                              <Select
                                value={
                                  selectedStatus[
                                  site?.clientBusinessUnitSiteID
                                  ] ?? site?.pqSiteStatus
                                }
                                disabled={!DisPayment.includes(info?.pqStatusId)}
                                onChange={(event) =>
                                  handleStatusChange(
                                    site?.clientBusinessUnitSiteID,
                                    event.target.value
                                  )
                                }
                                sx={{ width: "299px" }}
                                size="small"
                              >
                                {statuses  .filter((status) => ![-1].includes(status.prequalificationStatusId)).map((status) => (
                                  <MenuItem
                                    key={status.prequalificationStatusId}
                                    value={status.prequalificationStatusId}
                                  >
                                    {status.prequalificationStatus}
                                  </MenuItem>
                                ))}
                              </Select>

                              <Button
                                role="primary"
                                size="small"
                                label="Update"
                                sx={{ padding: "20px", marginTop: "5px" }}
                                disabled={!DisPayment.includes(info?.pqStatusId)}
                                onClick={(event) => {
                                  updateSiteStatus(
                                    site?.prequalificationSitesId,
                                    selectedStatus[
                                    site?.clientBusinessUnitSiteID
                                    ]
                                  );
                                }}
                              />
                            </Stack>
                          </Grid>
                        </Grid>
                      ))}
                    </div>
                  ))}
                </AccordionDetails>
              </Accordion>
            </div>
          ))}
        </Box>
      </Box >
    </>
  );
}
